var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoSearchTask = function SvgNoSearchTask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141,
    height: 105,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M27.279 44.838S10.26 83.072 55.065 83.608s65.282-5.335 65.485-24.797-15.932-37.615-44.058-37.82c-28.126-.206-43.334 7.13-49.213 23.847",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00D9A5",
    d: "M88.038 90.926v-15.32l15.397-1.37 2.751 16.69z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4A28C",
    d: "m85.179 67.793 3.822 5.35v2.379l13.468-1.199-.683-6.53s1.649-7.78-.413-12.845a17.7 17.7 0 0 1-1.193-7.376c.101-2.316-3.245-2.85-3.85-.606a21.4 21.4 0 0 0-.406 4.837c.01.82-.163 1.63-.504 2.376-.823 1.807-2.195 5.356-1.372 7.345l-1.585 7.76z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m92.462 69.267 1.362 5.826-4.823.429v-2.38l-3.822-5.349z",
    opacity: 0.09
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00D9A5",
    d: "M42.03 28.503s-3.114.697-3.552-3.1c-.437-3.796 0-5.224 0-5.224h7.326s3.717 9.143-3.773 8.324"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M42.03 28.503s-3.114.697-3.552-3.1c-.437-3.796 0-5.224 0-5.224h7.326s3.717 9.143-3.773 8.324",
    opacity: 0.08
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#035B60",
    d: "M47.526 15.672s-2.541-.062-3.115 3.529.819 8.567-2.38 9.302h8.935s5.499-12.608-3.44-12.83"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#00D9A5",
    d: "M53.105 15.673h-5.58a6 6 0 0 1 2.365 1.963 5.96 5.96 0 0 1 1.076 2.87v47.45c0 1.519.606 2.974 1.685 4.047a5.77 5.77 0 0 0 4.066 1.676H90.52a5.77 5.77 0 0 0 4.065-1.676 5.72 5.72 0 0 0 1.682-4.046V21.983a6.28 6.28 0 0 0-1.857-4.458 6.34 6.34 0 0 0-4.481-1.845z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60.16 26.632h24.277c.982 0 1.924.332 2.618.923s1.084 1.393 1.084 2.229v22.748c0 .836-.39 1.638-1.084 2.229s-1.636.923-2.618.923H60.16z",
    opacity: 0.35
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#035B60",
    d: "M88.725 59.539H59.762v7.352h28.963z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD200",
    d: "M74.15 48.421c4.366 0 7.907-3.523 7.907-7.868s-3.54-7.869-7.907-7.869c-4.368 0-7.908 3.523-7.908 7.869 0 4.345 3.54 7.868 7.907 7.868"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M74.15 46c3.023 0 5.474-2.439 5.474-5.447s-2.451-5.448-5.475-5.448-5.474 2.44-5.474 5.448S71.126 46 74.15 46"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD200",
    d: "M73.789 43.58a.7.7 0 0 1-.267-.052.6.6 0 0 1-.213-.144L71.242 41.2a.5.5 0 0 1-.11-.18.44.44 0 0 1 .053-.395.6.6 0 0 1 .154-.155.7.7 0 0 1 .214-.093.72.72 0 0 1 .467.044.6.6 0 0 1 .183.131l1.522 1.608 2.32-3.165a.6.6 0 0 1 .162-.155.723.723 0 0 1 .693-.027q.106.056.177.142.073.085.1.188a.44.44 0 0 1 .003.207.5.5 0 0 1-.09.19l-2.783 3.793a.6.6 0 0 1-.21.173.7.7 0 0 1-.281.072z"
  })));
};
export default SvgNoSearchTask;